import {NgModule} from "@angular/core";

import {PortalSlotDirective} from "./portal-slot.directive";
import {PortalSlotService} from "./portal-slot.service";


@NgModule({

  declarations: [
    PortalSlotDirective
  ],
  exports: [
    PortalSlotDirective
  ],
  providers: [
    PortalSlotService
  ]
})
export class PortalSlotModule {}
